import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Custo Mensal e Total por Vendedor, Doze Meses")
], -1)
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium fs-13 pt-0 ps-0 text-start"
    }, " Descrição "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
    }, " Valor R$ "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
    }, " Quantidade "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
    }, " Total R$ ")
  ])
], -1)
const _hoisted_7 = { class: "shadow-none lh-1 fw-semibold text-start" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-end text-black" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-end text-black" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-semibold text-end" }, " Total ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-end text-black" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-end text-black" }, null, -1)
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-end" }

import { onMounted, reactive } from "vue";
import custos from "./custos.json";
import { f2dec } from "@/utils/funcoes";

interface Item {
  mes: number,
  vlrCusto: number,
  qtdeVendas: number,
  qtdeAcum: number,
  vlrLucroMes: number,
  vendasAcum: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


var controle = reactive({
  total: 0,
})

onMounted(() => {

  calcularTotais();
})

function calcularTotais() {
  controle.total = 0;

  custos.forEach(a => {

    controle.total += parseInt(a.qtde ?? "1") * a.valor as number;
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(custos), (item, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", _hoisted_7, _toDisplayString(item.descricao), 1),
                _createElementVNode("td", _hoisted_8, " R$ " + _toDisplayString(_unref(f2dec)(item.valor)), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(item.qtde), 1),
                _createElementVNode("td", _hoisted_10, " R$ " + _toDisplayString(_unref(f2dec)((item.qtde || 0) * (item.valor || 0))), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("tfoot", null, [
            _createElementVNode("tr", null, [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("td", _hoisted_14, " R$ " + _toDisplayString(_unref(f2dec)(_unref(controle).total)), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})